<template>
  <div class="bg-light">
    <div style="padding-top: 55px" />
    <div
      class="album py-5 container"
      style="overflow: auto; height: calc(100vh - 55px)"
    >
      <div class="row">
        <div class="col-sm text-left">
          <!-- Change this section to whatever you would like -->
          <h1>{{ name }}</h1><p v-if="preApproval === false">ver {{ version }}</p>
          <hr />
          <div v-if="totalUsers === 0">
            <h3>You have successfully installed XAIMED Retina AI DL-FAS!</h3>
            <p>Use the registeration form to create an admin account</p>
          </div>
          <div v-else>
            <p>{{ name }} is a web-based software designed for retinal fundus image assistance.</p>
            <p>Login to analyze your images.</p>
          </div>
          <p v-if="preApproval === true" class="text-muted">본 소프트웨어는 의료기기 품목허가 전 제품(MVP)입니다. 의료기기법 제20조에 따른 기재사항은 허가 후 표시됩니다.</p>
          <div v-else-if="preApproval === false" class="accordion" id="informationAccordion">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    의료기기법 제20조에 따른 기재사항
                  </button>
                </h2>
              </div>
              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#informationAccordion">
                <div class="card-body">
                  <ul class="nobullets">
                    <li>가. 본 제품은 "의료기기"임</li>
                    <li>나. 품목명: {{ regulatory.item_name || '심혈관위험평가소프트웨어' }}</li>
                    <li>다. 모델명: {{ regulatory.model_name || 'XAIFN2211' }}</li>
                    <li>라. 품목허가번호: {{ regulatory.permit_number || '제허 24-436호' }}</li>
                    <li>마. 중량, 포장단위: 해당 없음</li>
                    <li>바. 의료기기 표준코드: {{ (regulatory && regulatory.udi) || '(01)08800309560005(10)1000003' }}</li>
                    <li>사. 사용목적: {{ regulatory.purpose || '안저카메라로 촬영한 안저영상을 분석하여 DL-FAS(deep-learning funduscopic atherosclerosis score)로 심혈관질환(경동맥죽상경화증, 관상동맥석회화증) 위험을 평가하여 의료인의 진단을 보조하는 소프트웨어' }}</li>
                    <li>아. 보관 또는 저장방법: 제품 설명서 참고</li>
                    <li>자. 기재사항 정보 고지: 기재사항 정보는 제품의 로그인 페이지에 게재함.</li>
                    <li>차. 제조의뢰자의 상호 및 주소</li>
                    <ul class="nobullets">
                      <li>1) 상호: 자이메드 주식회사</li>
                      <li>2) 주소: 서울특별시 종로구 율곡로 214, 5층 서울대학교병원 융합의학기술원</li>
                    </ul>
                    <li>카. 제조사의 상호 및 주소</li>
                    <ul class="nobullets">
                      <li>1) 상호: 인더스마트 주식회사</li>
                      <li>2) 주소: 서울특별시 종로구 대학로 71, 지하1층 일부</li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- End of section -->
        </div>
        <div class="col-sm">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: tab === 'login' }"
                id="home-tab"
                data-toggle="tab"
                href="#login"
                role="tab"
                aria-controls="home"
                aria-selected="true"
                @click="tab = 'login'"
              >
                Login
              </a>
            </li>
            <li class="nav-item" v-show="showRegistrationForm">
              <a
                class="nav-link"
                :class="{ active: tab === 'register' }"
                id="contact-tab"
                data-toggle="tab"
                href="#register"
                role="tab"
                aria-controls="contact"
                aria-selected="false"
                @click="showRegisterTab"
                ref="registerTab"
              >
                Register
              </a>
            </li>
          </ul>
          <div
            class="tab-content panel border-bottom border-right border-left text-left"
          >
            <div
              class="tab-pane fade"
              :class="{ 'show active': tab === 'login' }"
              id="login"
              role="tabpanel"
              aria-labelledby="login-tab"
            >
              <form class="vld-parent" ref="loginForm">
                <div class="form-group">
                  <label>Username</label>
                  <input
                    v-model="loginForm.username"
                    type="text"
                    class="form-control"
                    required
                  />
                  <div class="invalid-feedback">Invalid username format</div>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input
                    v-model="loginForm.password"
                    :class="inputPasswordClasses(loginForm.password)"
                    type="password"
                    class="form-control"
                  />
                  <div class="invalid-feedback">
                    <div v-if="!validPasswordLength(loginForm.password)"> At least 8 characters. </div>
                    <div v-if="!validPasswordUppercase(loginForm.password)"> At least one uppercase letter. </div>
                    <div v-if="!validPasswordLowercase(loginForm.password)"> At least one lowercase letter. </div>
                    <div v-if="!validPasswordNumber(loginForm.password)"> At least one number. </div>
                    <div v-if="!validPasswordSpecial(loginForm.password)"> At least one special character. </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-block"
                  :class="{ disabled: !loginValid }"
                  @click.prevent="loginUser"
                >
                  Login
                </button>
                <a
                  v-if="faqUrl"
                  :href="faqUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="d-block text-right mt-2"
                >
                  Need help? Contact us
                </a>
              </form>
            </div>
            <div
              class="tab-pane fade"
              :class="{ 'show active': tab === 'register' }"
              id="register"
              role="tabpanel"
              aria-labelledby="register-tab"
            >
              <div v-if="!showRegistrationForm">
                You are not allowed to register new accounts
              </div>
              <form v-else class="vld-parent" ref="registerForm">
                <div class="form-group" novalidate="">
                  <label
                    >Full Name <span class="text-mute">(Optional)</span></label
                  >
                  <input
                    v-model="registerForm.name"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>Username</label>
                  <input
                    v-model="registerForm.username"
                    :class="inputUsernameClasses(registerForm.username)"
                    type="text"
                    class="form-control"
                    required
                  />
                  <div class="invalid-feedback">Invalid username format</div>
                </div>

                <div class="form-group">
                  <label>Password</label>
                  <input
                    v-model="registerForm.password"
                    :class="inputPasswordClasses(registerForm.password)"
                    type="password"
                    class="form-control"
                    required
                  />
                  <div class="invalid-feedback">
                    <div v-if="!validPasswordLength(registerForm.password)"> At least 8 characters. </div>
                    <div v-if="!validPasswordUppercase(registerForm.password)"> At least one uppercase letter. </div>
                    <div v-if="!validPasswordLowercase(registerForm.password)"> At least one lowercase letter. </div>
                    <div v-if="!validPasswordNumber(registerForm.password)"> At least one number. </div>
                    <div v-if="!validPasswordSpecial(registerForm.password)"> At least one special character. </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Confirm Password</label>
                  <input
                    v-model="registerForm.confirmPassword"
                    :class="{
                      'is-valid':
                        registerForm.confirmPassword.length > 0 &&
                        registerForm.confirmPassword === registerForm.password
                    }"
                    type="password"
                    class="form-control"
                  />
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-block"
                  :class="{ disabled: !registerValid }"
                  @click.prevent="registerUser"
                >
                  Register
                </button>
                <a
                  v-if="faqUrl"
                  :href="faqUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="d-block text-right mt-2"
                >
                  Need help? Contact us
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoginFailureModal
      :visible="loginErrorModal.visible"
      :title="loginErrorModal.title"
      :body="loginErrorModal.body"
      @close="closeLoginErrorModal"
      @confirm="closeLoginErrorModal"
    />
  </div>
</template>

<script>
import toastrs from "@/mixins/toastrs";
import LoginFailureModal from "@/components/LoginFailureModal";
import { resolveLoginFailure } from "@/libs/loginError";
import { mapActions, mapMutations } from "vuex";
export default {
  name: "Authentication",
  mixins: [toastrs],
  components: {
    LoginFailureModal
  },
  props: {
    redirect: {
      type: Object,
      default() {
        return { name: "datasets" };
      }
    }
  },
  data() {
    return {
      tab: "login",
      registerForm: {
        loading: false,
        name: "",
        username: "",
        password: "",
        confirmPassword: ""
      },
      loginForm: {
        loading: false,
        username: "",
        password: ""
      },
      loginErrorModal: {
        visible: false,
        title: "",
        body: ""
      }
    };
  },
  methods: {
    ...mapActions("user", ["register", "login"]),
    ...mapMutations("info", ["increamentUserCount"]),
    /**
     * Reigsters a user with provided infomation from login form
     */
    registerUser() {
      if (!this.registerValid) return;

      let loader = this.$loading.show({
        container: this.$refs.registerForm,
        color: "#383c4a"
      });

      let data = {
        user: this.registerForm,
        successCallback: () => {
          loader.hide();
          this.increamentUserCount();
          this.$router.push(this.redirect);
        },
        errorCallback: error =>
          this.axiosReqestError(
            "User Registration",
            error.response.data.message
          )
      };

      this.register(data);
    },
    /**
     * Login a user with provided infomation from login form
     */
    loginUser() {
      if (!this.loginValid) return;

      let loader = this.$loading.show({
        container: this.$refs.registerForm,
        color: "#383c4a"
      });
      
      let data = {
        user: this.loginForm,
        successCallback: () => {
          loader.hide();
          // 리다이렉트는 isAuthenticated watcher가 처리하므로 여기서는 제거
        },
        errorCallback: error => {
          loader.hide();
          const loginFailure = resolveLoginFailure(error);
          this.loginErrorModal = {
            visible: true,
            title: loginFailure.title,
            body: loginFailure.body
          };
        }
      };

      this.login(data);
    },
    closeLoginErrorModal() {
      this.loginErrorModal.visible = false;
      this.loginForm.password = "";
    },
      
    /*
     * Returns boolean value if provide string is a valid username
     * @param {string} username
     * @returns {boolean} true if valid otherwise false
     */
    validUsername(username) {
      return /^[0-9a-zA-Z_.-]+$/.test(username);
    },
    /**
     * Returns boolean value if provide string is a valid password
     * @param {string} password
     * @returns {boolean} true if valid otherwise false
     */
    validPassword(password) {
      if (password.length < 8) return false;
      if (!/[a-z]/.test(password)) return false;
      if (!/[A-Z]/.test(password)) return false;
      if (!/[0-9]/.test(password)) return false;
      // Require at least one special character
      if (!/[^a-zA-Z0-9&\\;<>]/.test(password)) return false;
      return true;
    },
    validPasswordLength(password) {
      if (password.length < 8) return false;
      return true;
    },
    validPasswordLowercase(password) {
      if (!/[a-z]/.test(password)) return false;
      return true;
    },
    validPasswordUppercase(password) {
      if (!/[A-Z]/.test(password)) return false;
      return true;
    },
    validPasswordNumber(password) {
      if (!/[0-9]/.test(password)) return false;
      return true;
    },
    validPasswordSpecial(password) {
      // Require at least one special character
      if (!/[^a-zA-Z0-9&\\;<>]/.test(password)) return false;
      return true;
    },
    /**
     * Returns classes to be applied to a username input field for validation
     * @param {string} username input username string
     * @returns {object} validation classes
     */
    inputUsernameClasses(username) {
      let isValid = this.validUsername(username);

      return {
        "is-invalid": !isValid && username.length != 0,
        "is-valid": isValid
      };
    },
    /**
     * Returns classes to be applied to a password input field for validation
     * @param {string} password input password string
     * @returns {object} validation classes
     */
    inputPasswordClasses(password) {
      let isValid = this.validPassword(password);

      return {
        "is-invalid": !isValid && password.length != 0,
        "is-valid": isValid
      };
    },
    /**
     * Shows register tab
     */
    showRegisterTab() {
      this.tab = "register";
    }
  },
  computed: {
    registerValid() {
      if (!this.validUsername(this.registerForm.username)) return false;
      if (!this.validPassword(this.registerForm.password)) return false;
      if (this.registerForm.password !== this.registerForm.confirmPassword)
        return false;
      return true;
    },
    loginValid() {
      if (!this.validUsername(this.loginForm.username)) return false;
      if (this.loginForm.password.length == 0) return false;
      if (!this.validPassword(this.loginForm.password)) return false;
      return true;
    },
    totalUsers() {
      return this.$store.state.info.totalUsers;
    },
    allowRegistration() {
      return this.$store.state.info.allowRegistration;
    },
    showRegistrationForm() {
      return this.totalUsers == 0 || this.allowRegistration;
    },
    isAuthenticatePending() {
      return this.$store.state.user.isAuthenticatePending;
    },
    isAuthenticated() {
      return this.$store.state.user.isAuthenticated;
    },
    name() {
      return this.$store.state.info.name;
    },
    version() {
      return this.$store.state.info.version;
    },
    regulatory() {
      return this.$store.state.info.regulatory || {};
    },
    preApproval() {
      return this.$store.state.info.preApproval;
    },
    faqUrl() {
      return this.$store.state.info.faqUrl;
    }
  },
  watch: {
    totalUsers(users) {
      if (users === 0) {
        this.$refs.registerTab.click();
      }
    },
    isAuthenticated: {
      handler(newValue) {
        // 로그인 성공 시에만 리다이렉트
        if (newValue) {
          this.$router.push({
            name: "datasets"
          });
        }
      },
      immediate: true
    }
  },
  mounted() {}
};
</script>

<style scoped>
.panel {
  padding: 30px;
  background-color: white;
}

.text-mute {
  font-size: 10px;
}

.btn-button {
  margin-top: 10px;
}

ul.nobullets {
  list-style: none;
  margin: 3;  
  /* padding: 2; */
  padding-left: 1em;
  text-indent: -1em;
}

</style>
